// extracted by mini-css-extract-plugin
export default {"container":"Checkout_container__jyMtz","form":"Checkout_form__o4xj5","input":"Checkout_input__hk99Y"};